import * as React from 'react';
import styled from 'styled-components';
import Dropdown from './dropdown';
import LanguageDropdown from './language_dropdown';
import LanguageButton from './language_button';
import trackInMatomoAndGA from 'Shared/Analytics/CombinedGAMatomo';

const LanguageDropdownWrapper = styled(LanguageDropdown)`
   a:hover {
      text-decoration: none;
   }
`;

const LanguageDropdownContainer = ({
   // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'languages' implicitly has an 'any... Remove this comment to see the full error message
   languages,
   // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'translationPreferencesUrl' implic... Remove this comment to see the full error message
   translationPreferencesUrl,
   // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'machineTranslationRequested' impl... Remove this comment to see the full error message
   machineTranslationRequested,
}) => {
   const selectedLanguage = languages.find((language: any) => language.isSelected);
   const onMount = () => {
      trackInMatomoAndGA({
         eventCategory: 'Language',
         eventAction: 'Language Dropdown - Click',
      });
   };

   return (
      <Dropdown icon={<LanguageButton isoCode={selectedLanguage.isoCode} />} onMount={onMount}>
         <LanguageDropdownWrapper
            translationPreferencesUrl={translationPreferencesUrl}
            machineTranslationEnabled={true}
            machineTranslationRequested={machineTranslationRequested}
            languages={languages}
            isLightTheme={true}
         />
      </Dropdown>
   );
};

export default LanguageDropdownContainer;
